export default __webpack_public_path__ + "static/media/Greyce Braga_.04779ccf.png";